import { isAxiosError } from 'axios';

interface ErrorResponse {
  message: string;
  details?: string;
}

export const handleAxiosError = (
  res: unknown,
  defaultMessage: string,
): never => {
  if (isAxiosError<ErrorResponse>(res)) {
    const errorMessage = res.response?.data?.message ?? defaultMessage;
    const errorDetails = res.response?.data?.details ?? '';
    const errorStatus = res.response?.status ?? '';
    throw new Error(`${errorMessage} ${errorDetails ? `: ${errorDetails.trim()}` : ''}${errorStatus ? `Status: ${errorStatus}` : ''}`);
  }
  throw new Error(defaultMessage);
};
